import { render, staticRenderFns } from "./lineMallOrderList.vue?vue&type=template&id=67c3f2a1&scoped=true&"
import script from "./lineMallOrderList.vue?vue&type=script&lang=js&"
export * from "./lineMallOrderList.vue?vue&type=script&lang=js&"
import style0 from "./lineMallOrderList.vue?vue&type=style&index=0&id=67c3f2a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c3f2a1",
  null
  
)

export default component.exports